import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Toggler } from '@components';
import {
  RetornoContribuicaoInitialValues,
  RetornoContribuicaoSchema,
} from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const RetornoContribuicao = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RetornoContribuicaoInitialValues}
          validationSchema={RetornoContribuicaoSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <p className="mb-4">
                Venho, por meio deste, requerer o retorno das minhas
                contribuições para o Plano Misto de Benefícios Previdenciários –
                Plano B da Fundação Forluminas de Seguridade Social – FORLUZ, de
                acordo com o Regulamento do Plano.
              </p>
              <div className="row">
                <Field
                  className="mb-3"
                  name="declaracao"
                  component={Toggler}
                  label="Declaro, na oportunidade, não ter adquirido, durante o período de suspensão das contribuições, doença que, potencialmente, poderá me causar invalidez temporária ou permanente."
                />
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
